import Base from './Base.vue'
import Confirmation from './Confirmation.vue'
import Checkout from './Checkout.vue'
import Overview from './Overview'


export default{
    Base,
    Overview,
    Checkout,
    Confirmation
}


// WEBPACK FOOTER //
// ./src/views/customer/basket/index.js